import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { UIKitModule } from '@vendasta/uikit';
import { SharedModule } from '../../activation/shared/shared.module';
import { LegacyNotificationPreferenceService } from '../../user-notifications/legacy-notification-preference/legacy-notification-preference.service';
import { NotificationPreferencesModule } from '../../user-notifications/notification-preferences.module';
import { BulkUserImportComponent } from './bulk-import/bulk-user-import.component';
import { BulkUserImportService } from './bulk-import/bulk-user-import.service';
import { BulkNotificationsChangeComponent } from './bulk-notifications-change/bulk-notifications-change.component';
import { BulkTabAccessChangeComponent } from './bulk-tab-access-change/bulk-tab-access-change.component';
import { UserBulkActionsComponent } from './user-bulk-actions.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

const MAT_MODULES = [
  MatAutocompleteModule,
  MatTabsModule,
  MatIconModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatCardModule,
  MatButtonModule,
  MatStepperModule,
  MatGridListModule,
  MatInputModule,
];

@NgModule({
  imports: [
    CommonModule,
    MAT_MODULES,
    UIKitModule,
    SharedModule,
    TranslateModule,
    GalaxyPageModule,
    RouterModule,
    NotificationPreferencesModule,
    MatButtonToggleModule,
    GalaxyAlertModule,
  ],
  declarations: [
    UserBulkActionsComponent,
    BulkTabAccessChangeComponent,
    BulkNotificationsChangeComponent,
    BulkUserImportComponent,
  ],
  providers: [LegacyNotificationPreferenceService, BulkUserImportService],
})
export class UserBulkActionsModule {}
